<nav class="level">
  <!-- Left side -->
  <div class="level-left">
    <div class="level-item">
      <h2 class="title">Offers</h2>
    </div>
  </div>

  <!-- Right side -->
  <div class="level-right">
    <SearchInput bind:value={searchTerm} />
    &nbsp;
  </div>
</nav>

<div class="tabs">
  <ul>
    <PageTab page="published" label="Published" />
    <PageTab page="draft" label="Draft" />
    <PageTab page="pending" label="Pending approval" />
    <PageTab page="ended" label="Ended" />
  </ul>
</div>

<slot />

<script>
  import { offerSearchTerm } from './stores';
  import { setContext } from 'svelte';
  import PageTab from 'components/PageTab.svelte';

  import SearchInput from '../../_components/SearchInput.svelte';
  
  let searchTerm = '';

  setContext('searchInput', offerSearchTerm);
  
  $: offerSearchTerm.update((value) => (value = searchTerm));

</script>
